export type UsdTo = {
    value?:      number;
    gap?:        number;
    factor?:     number;
    finalValue?: number;
    factorReceived?: number;
    factorWithGap?: number;
}

export type ConvertCurrency = {
    value: number;
    amount: number;
    amountBase: number;
    factor: number;
    factorIncremented: number;
    fromCurrency: string;
    toCurrency: string;
    isCalcIncremented: boolean;
}
type Currency = {
    [key: string]: string;
};
type CurrencieTo = {
    [key: string]: string;
};

export const CURRENCIES: Currency = {
    "USD": "USD",
    "COP": "COP",
    "EUR": "EUR",   
    "BRL": "BRL",
};

export const CURRENCY_TO: CurrencieTo = {
    "USD_USD": `${CURRENCIES.USD}_${CURRENCIES.USD}`.toLowerCase(),
    "USD_COP": `${CURRENCIES.USD}_${CURRENCIES.COP}`.toLowerCase(),
    "USD_EUR": `${CURRENCIES.USD}_${CURRENCIES.EUR}`.toLowerCase(),
    "USD_BRL": `${CURRENCIES.USD}_${CURRENCIES.BRL}`.toLowerCase(),
} 

/*
*   amount: number
*   fromCurrency: string
*   toCurrency: string
*   currencyValues: UsdTo | undefined
*   return: number | null
*/

export const convertValue = ({  
    isDolarBase = false,
    amount,
    fromCurrency,
    toCurrency,
    currencyValues,
    isCalcIncremented = false,
    isLogger = false
}: {
    isDolarBase: boolean;
    amount: number;
    fromCurrency: string;
    toCurrency: string;
    currencyValues: UsdTo | undefined;
    isCalcIncremented?: boolean,
    isLogger?: boolean,
    }) : ConvertCurrency | null => {

        const convertionKey: string = `${fromCurrency}_${toCurrency}`?.toLowerCase() || "";

        if (!currencyValues) {
            console.warn("currencyValues is undefined. Cannot perform currency conversion.");
            return null;
        }

        const conversionData = currencyValues[convertionKey as keyof UsdTo] || {finalValue: 0, gap: 0, value: 0, factor: 0, factorWithGap: 0};
        const _fromCurrency = isDolarBase ? toCurrency : fromCurrency;
        const _toCurrency = isDolarBase ? fromCurrency : toCurrency;
        if(isLogger) {
            console.log('convertionKey', convertionKey)
            console.log('conversionData', conversionData)
        }

        // Check if conversionData exists and has a finalValue
        if (convertionKey in currencyValues && typeof conversionData === 'object' && 'finalValue' in conversionData) {
            
            if(isLogger) {
                console.log('convertCurrency', {
                    finalValue: conversionData.finalValue,
                    gap: conversionData.gap,
                    value: conversionData.value,
                    factor: conversionData.factor,
                    factorWithGap: conversionData.factorWithGap,
                    isDolarBase,
                })
            }
            const convertedAmount 
            = isDolarBase
                ? amount * conversionData.factor
                : amount * conversionData.finalValue;
            return {
                value: convertedAmount,
                amountBase: conversionData.finalValue,
                amount,
                factor: conversionData.factor,
                factorIncremented: conversionData.factorWithGap,
                isCalcIncremented,
                fromCurrency: _fromCurrency,
                toCurrency: _toCurrency,
            };
        } 

        if(isLogger) {
        console.warn(`Conversion rate not found for ${convertionKey}.`);
        }
        
    return {
        value: 0,
        amountBase: amount,
        amount,
        factor: 0,
        factorIncremented: 0,
        isCalcIncremented,
        fromCurrency: _fromCurrency,
        toCurrency: _toCurrency,
    };
    
}
export const convertCurrency =  ({
    amount,
    fromCurrency,
    toCurrency,
    currencyValues,
    isCalcIncremented = false,
    isDolarBase = false,
    isLogger = false,
}: {
    amount: number;
    fromCurrency: string;
    toCurrency: string;
    currencyValues: UsdTo | undefined,
    isCalcIncremented?: boolean,
    isDolarBase?: boolean,
    isLogger?: boolean,
}) : ConvertCurrency | null => {

    fromCurrency = fromCurrency?.toUpperCase()
    toCurrency = toCurrency?.toUpperCase()
   
    if (!currencyValues) {
        console.warn("currencyValues is undefined. Cannot perform currency conversion.");
        return null;
      }

    const convertionKey: string = `${fromCurrency}_${toCurrency}`?.toUpperCase() || "";

    if(isLogger) {
        console.log('convertionKey', convertionKey, CURRENCY_TO.USD_USD)
    }

    if(convertionKey === CURRENCY_TO.USD_USD) {
       
        const response = convertValue({
            amount,
            fromCurrency: CURRENCIES.USD,
            toCurrency: CURRENCIES.COP,
            currencyValues,
            isLogger,
            isDolarBase: false,
        })

        if(isLogger) {
            console.log('response', JSON.stringify(response, null, 2))
        }

        return response;
    }
    return convertValue({
        isDolarBase,
        amount,
        fromCurrency,
        toCurrency,
        currencyValues,
        isCalcIncremented,
        isLogger,
    })
    
};